import fetch from 'isomorphic-unfetch';
import config from '../../../config';

const { apiHost } = config;

const getGettingStartedPageContent = () => async (dispatch) => {
    dispatch({
        type: 'GETTING_STARTED_PAGE_CONTENT:FETCH_REQUEST',
    });

    const res = await fetch(`${apiHost}/v2/content/gettingstarted-page`);
    const data = await res.json();

    if (data.error) {
        dispatch({
            type: 'GETTING_STARTED_PAGE_CONTENT:FETCH_FAILURE',
            data: data.error,
        });
    } else {
        dispatch({
            type: 'GETTING_STARTED_PAGE_CONTENT:FETCH_SUCCESS',
            data: data.contentSlices,
        });
    }
};

export default getGettingStartedPageContent;
